<template>
    <div>
      <app-tab :tabs="tabsHorizontal" type="horizontal" />

      </div>
</template>

<script>
export default {
  name: "WorkspaceMainContent",
  props: {
    companyId: Number,
    jobId: Number,
  },
  data() {
    return {
      icon: "settings",
      tabsHorizontal: [
         {
          name: "Board",
          component: "workspace-board",
          icon: 'book',
          props: {companyId: this.companyId, jobId: this.jobId},
        },
        {
          name: "Calendar",
          component: "workspace-calendar",
          icon: 'calendar',
          props: {companyId: this.companyId, jobId: this.jobId},
        },
        {
          name: "List",
          component: "workspace-list",
          icon: 'list',
          props: {companyId: this.companyId, jobId: this.jobId},
        },
        {
          name: "View",
          component: "workspace-view",
          icon: 'plus',
          props: {companyId: this.companyId, jobId: this.jobId},
        },
      ],
    };
  },
};
</script>